import state from '../../state'
import winterfell from '@mc-alberta/winterfell'
import { popup as popupManager } from '@mc-alberta/tyrion'
import { lumber } from '@mc-alberta/lumber'
import { createMerchantCallbackUrl } from '../../utils/merchant'
import events from '../../../events.json'

/**
 * completeCheckout
 * @description Completes the checkout procedure and redirects to the merchant callback page with
 * the correct v7 parameters.
 */
export async function completeCheckout ({ checkoutResponseSignature, checkoutResponse }) {
  try {
    const { srciTransactionId } = winterfell.merchantData()

    // Save payment data
    await winterfell.savePaymentData({
      transactionId: srciTransactionId,
      checkoutResponseSignature,
      srcCorrelationId: checkoutResponse.srcCorrelationId
    })

    // End session
    return redirect('success', {
      srciTxId: srciTransactionId
    })
  } catch (e) {
    lumber.error({
      ...events.errors.COMPLETE_CHECKOUT,
      details: {
        message: `There was an error in completing the checkout`,
        dcfActionCode: `COMPLETE`
      }
    })

    // End session
    return abortCheckout()
  }
}

/**
 * abortCheckout
 * @description Aborts the checkout procedure and redirects to the merchant callback page with
 * the correct v7 parameters.
 */
export function abortCheckout () {
  return redirect()
}

/**
 * redirect
 * @description Clears the states, closes the popup and redirects the merchant to the appropriate location
 */
function redirect (status = 'cancel', params = {}) {
  const { dpaCallbackUrl: callbackUrl } = winterfell.merchantData()

  // Reset states
  winterfell.clearState()
  state.aggregator.store.resetState()

  // Close popup
  popupManager.getWindow().close()

  // Redirect to merchant
  const merchantCallbackUrl = createMerchantCallbackUrl({
    callbackUrl,
    status,
    ...params
  })
  if (merchantCallbackUrl) {
    window.location.assign(merchantCallbackUrl)
  }
}
